export class ApplicantCloneFactoryConstant {
  static readonly BUSINESS: string = "BUSINESS";
  static readonly ADDRESS: string = "address";
  static readonly PHONE: string = "phone";
  static readonly EMAIL: string = "email";
  static readonly IDENTIFICATION: string = "identification";
  static readonly EMPLOYMENT: string = "employment";
  static readonly DEMOGRAPHIC: string = "demographic";
}
